import { useMemo, useRef } from "react";
import { useQuery } from "react-query";

import { thongBaoApi } from "src/1/apis/thong_bao.api";

import { ReactComponent as NotiIcon } from "./notification.svg";
import { NotificationContainer } from "./NotificationContainer";

import "./styles.scss";

export const CNotification = () => {
  //#region Data
  const { data: notifications = [] } = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => thongBaoApi.getAll(),
    select: (response) =>
      response?.data?.data?.map((e) => ({
        ...e,
        notification_content: e?.notification_content
          ? JSON.parse(e?.notification_content)
          : "",
      })),
  });

  const unreadNotifications = useMemo(
    () => notifications?.filter((e) => !!e?.read_date) ?? [],
    [notifications],
  );

  const notiListRef = useRef(null);
  //#endregion

  //#region Event
  const onOpenList = () => {
    notiListRef.current?.open();
  };
  //#endregion

  //#region Render
  return (
    <div id="header-notification-wrapper">
      <div id="header-notification" onClick={onOpenList}>
        <NotiIcon />
      </div>

      {unreadNotifications.length > 0 && (
        <div id="notification-badge">
          {unreadNotifications.length >= 10 ? "9+" : unreadNotifications.length}
        </div>
      )}

      <NotificationContainer
        ref={notiListRef}
        notifications={notifications}
        unreadNotifications={unreadNotifications}
      />
    </div>
  );
  //#endregion
};
